var map = {
	"./flags/australia.png": 55658,
	"./flags/belgium.png": 55267,
	"./flags/brazil.png": 71800,
	"./flags/canada.png": 84088,
	"./flags/china.png": 15693,
	"./flags/france.png": 28747,
	"./flags/germany.png": 95055,
	"./flags/india.png": 95565,
	"./flags/italy.png": 8657,
	"./flags/japan.png": 18172,
	"./flags/netherlands.png": 92052,
	"./flags/poland.png": 64482,
	"./flags/portugal.png": 12656,
	"./flags/russia.png": 55313,
	"./flags/spain.png": 35235,
	"./flags/sweden.png": 83214,
	"./flags/united-kingdom.png": 62507,
	"./flags/united-states.png": 80720,
	"./institutions/building.png": 73260,
	"./institutions/city.png": 41221,
	"./institutions/hospital.png": 78338,
	"./institutions/industry.png": 54518,
	"./institutions/landmark.png": 20836,
	"./institutions/school.png": 88656,
	"./institutions/shield.png": 91147,
	"./institutions/shop.png": 43648,
	"./institutions/store.png": 86537,
	"./institutions/warehouse.png": 26839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40784;